<template>
    <div class="form">
        <Form ref="info" :model="info" :rules="ruleValidate" :label-width="100">
            <Row :gutter="20">
                <Col span="12">
                    <FormItem prop="paymentDate" :label="`已${statusText}款日`">
                        <DatePicker
                            v-model="info.paymentDate"
                            style="width: 100%"
                            type="datetime"
                            placeholder
                        >
                        </DatePicker>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem prop="realAmount" :label="`已${statusText}金额`">
                        <input-number
                            v-model="info.realAmount"
                            placeholder
                            disabled
                        >
                            <span slot="append">元</span>
                        </input-number>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="交易方式" prop="payType">
                        <Select
                            v-model="info.payType"
                            transfer
                            placeholder="请选择交易方式"
                        >
                            <Option
                                v-for="item in dict.payType.toList()"
                                :value="item.id"
                                :key="item.id"
                                >{{ item.text }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
            </Row>

            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="上传图片" prop="attachments">
                        <preview-upload
                            v-model="info.attachments"
                            multiple
                            :format="imgSuffix"
                            :maxNumber="10"
                        ></preview-upload>
                    </FormItem>
                </Col>
            </Row>

            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="备注" prop="remark">
                        <Input
                            v-model="info.remark"
                            type="textarea"
                            :rows="3"
                            placeholder
                        ></Input>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import Dict from '_u/dict'
import config from '@/config'
import { deepCopy, ymdL } from '_u/helper'
import { multiply } from '@/views/common/u-contract'

import PreviewUpload from '_c/preview-upload'

import { billBatchPayment } from '@/api/bill'

export default {
    name: 'BillBatchPaymentForm',

    props: {
        id: {
            type: [String, Number],
            default: '',
        },
        billStatus: {
            type: [String, Number],
            default: '',
        },
        amount: {
            type: [String, Number],
            default: '',
        },
    },

    components: { PreviewUpload },

    inject: {
        $modal: {
            default: null,
        },
    },

    data() {
        return {
            info: {
                ids: this.id, // 账单编号
                billStatus: this.billStatus, // 账单状态
                paymentDate: new Date(), // 已收款时间/已付款时间
                realAmount: this.amount, // 实际收款/付款金额
                payType: '', // 支付方式
                attachments: '', // 附件
                remark: '',
                ver: '',
            },
            imgSuffix: config.upload.imgSuffix,
            dict: {
                payType: Dict.NULL,
            },
        }
    },
    computed: {
        ruleValidate() {
            return {
                paymentDate: [
                    {
                        required: true,
                        message: `已${this.statusText}款日必填`,
                    },
                ],
                payType: [
                    {
                        required: true,
                        message: '交易方式必填',
                    },
                ],
            }
        },
        statusText() {
            return this.billStatus === '1' ? '收' : '付'
        },
    },
    mounted() {
        var $info = this.$refs.info

        // 按钮配置
        var btns = [{ type: 'default', text: '取消', name: 'cancel' }]

        if (this.$can('update')) {
            btns.unshift({
                type: 'primary',
                name: 'confirm',
                text: '确定',
            })
        }
        this.$modal.updateBtns(btns)

        // 预加载
        this.$modal.beforeEnter((next) => {
            Promise.all([Dict.get(['pay_type'])])
                .then((args) => {
                    var [dictGroup] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })
                })
                .finally(() => {
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then(() => {
                    var formData = deepCopy(this.info)
                    formData.realAmount = multiply(formData.realAmount)
                    formData.paymentDate = ymdL(formData.paymentDate)
                    return billBatchPayment(formData)
                })
                .then((res) => {
                    this.$emit('success')
                    this.$Message.success(`批量${this.statusText}款成功`)
                })
                .catch((err) => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    },
}
</script>
<style lang="less" scoped></style>
